// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3HAYk","list":"BalanceDue_list__3YaId","listRow":"BalanceDue_listRow__3Ev6R","total":"BalanceDue_total__vOvyw"};